import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService } from '@layouts/default/layouts/logged/pages/events/events.service';
import { BaseComponent } from '@shared/components/base.component';

@Component({
  selector: 'app-event-tooltip',
  templateUrl: './event-tooltip.component.html',
  styleUrls: ['./event-tooltip.component.scss'],
})
export class EventTooltipComponent extends BaseComponent {
  @Input() event: any;

  constructor(public router: Router, public eventService: EventsService) {
    super();
  }

  goToEvent(id: number) {
    this.router.navigate([`/events/${id}/`]);
  }

  getAddress() {
    const { address } = this.event;
    let string = [];
    if (address.street) {
      string.push(address.street);
    }
    if (address.city) {
      string.push(address.city);
    }
    if (address.country) {
      string.push(this.translate.instant('COUNTRIES.' + address.country));
    }

    return string.join(', ');
  }

  getMonth() {
    return this.eventService.getMonth(this.event.start_at);
  }

  getDay() {
    return this.eventService.getDay(this.event.start_at);
  }

  getYear() {
    return this.eventService.getYear(this.event.start_at);
  }

  getImage() {
    if (this.event.image) {
      return this.event.image;
    } else if (this.event.event_theme_id) {
      return this.event.event_theme_image;
    } else {
      return '/assets/img/img-placeholder-event.webp';
    }
  }
}
